var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as moment from 'moment';
import Vue from 'vue';
import VueSnotify from 'vue-snotify';
import VueResource from 'vue-resource';
import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n';
import VueTheMask from 'vue-the-mask';
import VueMoney from 'v-money';
import { Lang, Currency } from './enums';
import { currencyConfig } from './helpers';
import { AwaitController } from './components/utils/Await';
import { ModalController } from './components/utils/Modal';
import { TipController } from './components/utils/Tip';
import { defaultFilters, defaultComponents } from './config';
Vue.use(VueSnotify);
Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(VueTheMask);
var router = new VueRouter();
var i18n = new VueI18n();
var bus = new Vue({ i18n: i18n, router: router });
export var $ = {
    apiURL: '',
    socketURL: '',
    component: {},
    filter: {},
    router: router,
    i18n: i18n,
    bus: bus,
    http: bus.$http,
    resource: bus.$resource,
    route: bus.$route,
    t: bus.$t,
    tc: bus.$tc,
    te: bus.$te,
    d: bus.$d,
    n: bus.$n,
    snotify: bus.$snotify,
    await: new AwaitController(),
    modal: new ModalController(),
    tip: new TipController(),
};
var defaultApiURL = 'http://localhost/api';
var defaultSocketURL = 'ws://localhost/ws';
var defaultLang = Lang.EN_US;
var defaultCurrency = Currency.USD;
var Simpli = /** @class */ (function () {
    function Simpli() {
    }
    Simpli.init = function () {
        if (this.httpInterceptor) {
            Vue.http.interceptors[7] = Simpli.httpInterceptor;
        }
        // Ignore last slash (/)
        var regexApi = Simpli.apiURL.match(/(.*)[^\/$]/g);
        if (regexApi)
            $.apiURL = regexApi[0] || defaultApiURL;
        // Ignore last slash (/)
        var regexSocket = Simpli.socketURL.match(/(.*)[^\/$]/g);
        if (regexSocket)
            $.socketURL = regexSocket[0] || defaultSocketURL;
        $.component = __assign({}, defaultComponents, Simpli.components);
        $.filter = __assign({}, defaultFilters, Simpli.filters);
        $.router = new VueRouter(Simpli.router);
        $.i18n = new VueI18n({
            locale: Simpli.lang,
            messages: Simpli.locale,
        });
        $.bus = new Vue({ router: $.router, i18n: $.i18n });
        var component = $.component;
        var filter = $.filter;
        var i18n = $.i18n;
        var bus = $.bus;
        $.resource = bus.$resource;
        $.http = bus.$http;
        $.route = bus.$route;
        $.snotify = bus.$snotify;
        $.t = bus.$t;
        $.tc = bus.$tc;
        $.te = bus.$te;
        $.d = bus.$d;
        $.n = bus.$n;
        Vue.use(VueMoney, currencyConfig(Simpli.currency));
        moment.locale(i18n.locale);
        if (filter) {
            Object.keys(filter).forEach(function (key) { return Vue.filter(key, filter[key]); });
        }
        if (component) {
            Object.keys(component).forEach(function (key) {
                Vue.component(key, component[key]);
            });
        }
        Vue.prototype.$apiURL = $.apiURL;
        Vue.prototype.$socketURL = $.socketURL;
        Vue.prototype.$bus = $.bus;
        Vue.prototype.$await = $.await;
        Vue.prototype.$modal = $.modal;
        Vue.prototype.$tip = $.tip;
    };
    Simpli.apiURL = defaultApiURL;
    Simpli.socketURL = defaultSocketURL;
    Simpli.lang = defaultLang;
    Simpli.currency = defaultCurrency;
    Simpli.components = {};
    Simpli.filters = {};
    return Simpli;
}());
export { Simpli };
//# sourceMappingURL=simpli.js.map